<template>
  <main>
    <section class="basic-infos">
      <h1 class="side-title">Melanie's <span class="color-primary">{{ fragUrsContent.title }}e</span> Route</h1>
    </section>
    <section class="routeDetailView container">
      <!-- <pre>{{ fragUrsContent }}</pre> -->
      <RouteMap :route="fragUrsContent" :useContentful="useContentful"/>
      <!-- <RoutePreview :route="fragUrsContent"></RoutePreview> -->
      <section class="route">
        <ul class="partRoutes">
          <li v-for="partRoute in fragUrsContent.partRoutes" v-bind:class="'partRoute ' + partRoute.fields.routeMode.fields.title">

            <div class="location">
              {{ /* take just start point of one route */ }}
              {{ partRoute.fields.locations[0].fields.title }} {{ /* partRoute.fields.routeMode.fields.title */ }}
            </div>

            <ul class="attractions">
              <li v-for="(item, index) in partRoute.fields.items" :key="index">
                <article v-bind:class="'attraction ' + item.fields.attractionType.fields.title">
                  <figure class="attraction-image">
                    <img v-bind:src="item.fields.attractionImage.fields.file.url" :alt="item.fields.title" class="img-fluid"/>
                    <h5 class="attraction-title">{{ item.fields.title }} {{ /* item.fields.attractionType.fields.title */ }}</h5>
                  </figure>
                  <p class="attraction-description">{{ item.fields.description }}</p>

                  <figure class="urs-idea urs" v-if="item.fields.attractionType.fields.title == 'Kulinarisch' && index == 1">
                    <img src="../assets/urs_bubble.svg" />
                    <figcaption>
                      <p>Willst du noch mehr Kulinarik?</p>
                    </figcaption>
                  </figure>
                </article>
              </li>
            </ul>

            <div class="location" v-if="partRoute.fields.locations.length && partRoute.fields.locations[1]">
              Location 2 {{ partRoute.fields.locations[1].fields.title }}
            </div>
          </li>
        </ul>
      </section>
    </section>
  </main>
</template>

<script>
import RouteMap from '@/components/RouteMap.vue';
// import RoutePreview from '@/components/RoutePreview.vue';
import { contentfulEnvironment } from '../js/contentful';
import { contentfulEntries } from '../js/entries';

export default {
  name: 'routeDetail',
  components: {
    RouteMap,
    // RoutePreview,
  },
  data() {
    return {
      fragUrsContent: {},
      contentfulItems: [],
      useContentful: false,
    };
  },
  async mounted() {
    /**
     * Contentful
     */
    let entries;
    if (this.useContentful) {
      console.log('from contentful');
      const env = await contentfulEnvironment;
      entries = await env.getEntries({
        content_type: 'route',
        resolveLinks: true,
        include: 10,
      });
    } else {
      console.log('data from static js');
      entries = contentfulEntries;
    }

    // put field in array
    const items = entries.items.map((value, index, array) => value.fields);

    // sort array
    items.sort((a, b) => a.id - b.id);

    // bind items to data -- not reactive?
    this.contentfulItems = items;
    this.fragUrsContent = items[(this.$route.params.id) - 1];
    console.log(this.fragUrsContent);
  },
  computed: {
    from() {
      if (this.fragUrsContent.locations) {
        return this.fragUrsContent.locations[0].fields.title;
      }
      return '';
    },
    to() {
      if (this.fragUrsContent.locations) {
        return this.fragUrsContent.locations[1].fields.title;
      }
      return '';
    },
  },
  watch: {
    $route(to, from) {
      this.fragUrsContent = this.contentfulItems[(to.params.id) - 1];
    },
  },
};
</script>

<style lang="scss">
.routeDetailView {
  display: flex;
  flex-direction: row;
  padding-top: 80px;
  align-items: flex-start;
}

.route {
  width: 65%;
  padding-left: 80px;

  $offset-left: 45px;
  $offset-line-top: 50px;

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .partRoutes {
    .partRoute {
      position: relative;
      padding-left: $offset-left;
      margin-bottom: 20px;
      min-height: 100px;

      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: $offset-line-top;
        width: 1px;
        height: calc(100% - #{$offset-line-top});
        transform: translateX(-50%);
      }

      &::after {
        content: "";
        display: none;
        height: 30px;
        width: 30px;
        position: absolute;
        top: 45px;
        left: -40px;
      }

      &.Zug {
        &::before {
          // background: var(--color-dark-blue);
          border-left: 1.5px solid var(--color-dark-blue);
          border-right: 1.5px solid var(--color-dark-blue);
          width: 5px;
        }

        &::after {
          background-image: url(../assets/icons/train.svg);
        }

        .location{
          &::before{
            background-image: url(../assets/icons/train.svg);
          }
        }
      }

      &.Fahrrad {
        &::before {
          width: 2px;
          background: var(--color-jade);
        }
        &::after {
          background-image: url(../assets/icons/bicycle.svg);
        }

        .location{
          &::before{
            background-image: url(../assets/icons/bicycle.svg);
            height:40px;
            width:40px;
            left: calc(-#{$offset-left} - 20px);
          }
        }
      }

      &.Fuss {
        &::before {
          // background: var(--color-primary);
          width: 1px;
          border: 1px dashed var(--color-dark-red);
        }

        &::after {
          background-image: url(../assets/icons/walk.svg);
        }

        .location{
          &::before{
            background-image: url(../assets/icons/walk.svg);
          }
        }
      }

      &.Bus {
        &::before {
          background: var(--color-orange);
          width: 1px;
        }

        &::after {
          background-image: url(../assets/icons/bus.svg);
        }

        .location{
          &::before{
            background-image: url(../assets/icons/bus.svg);
          }
        }
      }

      .partRouteTitle {
        display: flex;
      }

      .location {
        // margin-left: - $offset-left;
        margin-bottom: 25px;
        margin-top: $offset-line-top;
        font-size: 1.6rem;
        position: relative;
        font-weight: 600;

        &:first-child{
          margin-top: 0;
        }
       
        &::before{
          // icon auf timeline
          content: '';
          display: block;
          height:36px;
          width:36px;
          background-image: url('../assets/icons/Marker_green.svg');
          background-repeat: no-repeat;
          background-position: center;
          position: absolute;
          left: calc(-#{$offset-left} - 18px);
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .attractions{
        padding-top: 30px;
        padding-bottom: 40px;

        li{
          &:last-child{
            .attraction{
               margin-bottom:0;
            }
          }
        }
      }

      .attraction {
        background:transparent;
        margin-bottom: 60px;
        position: relative;

        &.Wissen {
          .attraction-title {
            color: var(--color-dark-blue);
            // transform: rotate(-90deg) translateY(535%) translateX(55%);
            justify-content: flex-end;
            text-transform: uppercase;
          }

          .attraction-image, .attraction-description {
            width: calc(100% - 50px);
          }
        }

        &.Kulinarisch {
          .attraction-title {
            color: var(--color-orange);
            text-transform: uppercase;
            font-size: 1.5rem;
          }

          .attraction-image, .attraction-description {
            width: 50%;
          }

          &:first-child{
            .urs-idea{
              display: block;
            }
          }
        }

        &.Aktivitaet {
          .attraction-title {
            color: var(--color-dark-red);
            text-transform: uppercase;
          }

          .attraction-image, .attraction-description {
            width: 80%;
          }
        }

        .attraction-image {
          display: flex;
          align-items: flex-start;

          img {
            // object-fit: cover;
          }
        }

        .attraction-title {
          font-size: 1.8rem;
          text-transform: uppercase;
          font-weight: 400;
          transform-origin: top left;
          transform: rotate(-90deg) translateX(-100%) translateY(0px);
          font-size: 3rem;
          font-weight: 400;
          margin-left: 15px;
          display: inline-block;
          line-height: 1;
        }

        .attraction-description {
          // padding: 10px 10px 10px;
          font-size: 1rem;
          font-weight:500;
          margin-top: 15px;
          line-height:1.25rem;
        }

        .urs-idea{
          position: absolute;
          display: none;
          bottom: 15px;
          right: 15px;
          z-index: 1;
          width: 40%;
          animation-name: 'urs-idea';
          animation-iteration-count: infinite;
          animation-direction: alternate;
          animation-duration:1.5s;
          animation-timing-function: ease-in-out;
          transform-origin: 75% 100%;

          @media screen and (max-width: 1199px){
            width: 63%;
          }

          img{
            display: block;
            width: 100%;
          }

          figcaption{
            position: absolute;
            top: 0;
            width: 53%;
            left: 0;
            bottom: 63%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 27px;
            border-radius: 53%;
            flex-direction: column;
            text-align: center;
            font-size: .85rem;
            font-weight:600;
            line-height:1rem;
            color: var(--color-orange);

            p:not(:last-child){
              margin-bottom:5px;
            }
          }

          @keyframes urs-idea {
            from {
              transform: rotate(0);
            }

            to {
              transform: rotate(2deg);
            }
          }
        }
      }
    }
  }
}
</style>
